import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveCateogry } from "../../services/categoryService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";

class CategoryForm extends Form {
  state = {
    data: {
      name: "",
      description: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Category name"),
    description: Joi.string().required().label("Description"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveCateogry(this.state.data);
      toast.success("Category has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/categories");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add Category</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/categories")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add Category</h3>
              <p>Provide the information below to add the category.</p>
              {this.renderInput("name", "Name", "text")}
              {this.renderInput("description", "Description", "text")}
              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default CategoryForm;
